import React from "react";
import { Flex, Text, SimpleGrid, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Filter } from "iconsax-react";
import { IParamsPerformance } from "../../hooks";
import { Select } from "../";
import ModalRangeDate from "./ModalRangeDate";
import { EDiary, EIsBackTest, EPeriod } from "../../interfaces/Filters";

interface IProps {
  query: IParamsPerformance;
  setQuery: React.Dispatch<React.SetStateAction<IParamsPerformance>>;
  initialDate: string;
  available_symbols?: string[];
}
export default function FiltersPerformance({
  query,
  setQuery,
  initialDate,
  available_symbols = [],
}: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  const optionsIsBackTest = [
    {
      label: "global.graphic_performance.filters.is_backtest_all",
      value: EIsBackTest.All,
    },
    {
      label: "global.graphic_performance.filters.is_backtest_true",
      value: EIsBackTest.True,
    },
    {
      label: "global.graphic_performance.filters.is_backtest_false",
      value: EIsBackTest.False,
    },
  ];

  const optionsDiary = [
    {
      label: "global.graphic_performance.filters.diary_accumulated",
      value: EDiary.Accumulated,
    },
    {
      label: "global.graphic_performance.filters.diary_daily",
      value: EDiary.Daily,
    },
    {
      label: "global.graphic_performance.filters.diary_accumulated_percentage",
      value: EDiary.AccumulatedPercenteg,
    },
    {
      label: "global.graphic_performance.filters.diary_daily_percentage",
      value: EDiary.DailyPercenteg,
    },
  ];

  const optionsSymbols = [
    {
      label:
        t("global.graphic_performance.filters.symbol_all") ||
        "Todos os símbolos",
      value: "",
    },
    ...(available_symbols?.map((symbol) => ({
      label: symbol,
      value: symbol,
    })) || []),
  ];

  const handleSelectIsBackTest = (value: EIsBackTest) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      is_backtest: value,
      period: EPeriod.All,
    }));
  };

  const handleSelectDiary = (value: EDiary) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      diary: value,
      period: EPeriod.All,
    }));
  };

  const handleSelectSymbol = (value: string | null) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      symbols: value && value !== "" ? [value] : undefined,
      period: EPeriod.All,
    }));
  };

  const selectedSymbol =
    query.symbols && query.symbols.length > 0 ? query.symbols[0] : "";

  return (
    <Flex direction={"column"} gap="20px" my="20px">
      <Flex justify="start" align={"center"} gap="8px">
        <Filter size="24" color={theme.colors.basic[5]} />
        <Text fz={{ base: 20 }} lh={{ base: "32px" }} c={theme.colors.basic[5]}>
          {t("global.graphic_performance.filters.title")}
        </Text>
      </Flex>
      <SimpleGrid
        breakpoints={[
          { minWidth: "100", cols: 1 },
          { minWidth: "800", cols: 2 },
          { minWidth: "1200", cols: 3 },
          { minWidth: "1500", cols: 4 },
        ]}
      >
        <ModalRangeDate
          query={query}
          setQuery={setQuery}
          initialDate={initialDate}
        />

        <Select
          data={optionsIsBackTest}
          value={query.is_backtest}
          placeholder={t("global.graphic_performance.filters.is_backtest")}
          label={t("global.graphic_performance.filters.is_backtest")}
          onChange={handleSelectIsBackTest}
          w="100%"
        />
        <Select
          data={optionsDiary}
          value={query.diary}
          placeholder={t("global.graphic_performance.filters.diary")}
          label={t("global.graphic_performance.filters.diary")}
          onChange={handleSelectDiary}
          w="100%"
        />
        <Select
          data={optionsSymbols}
          value={selectedSymbol}
          placeholder={
            t("global.graphic_performance.filters.symbol") ||
            "Selecionar símbolo"
          }
          label={t("global.graphic_performance.filters.symbol") || "Símbolo"}
          onChange={handleSelectSymbol}
          w="100%"
          disabled={!available_symbols || available_symbols.length === 0}
        />
        {/* <MultiSelectSymbols
          query={query}
          setQuery={setQuery}
          available_symbols={available_symbols}
        /> */}
      </SimpleGrid>
    </Flex>
  );
}
